import { Message } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./DirectLabsBlockedState.styles";

type BlockedClass = "structural" | "stateRestricted";

interface Props {
  blockedClass: BlockedClass;
}

/**
 * Blocked-state panel for the direct-lab entry page, reusing existing lab
 * messaging patterns:
 * - structural unavailability (not found / inactive / unsupported /
 *   auth-network false / store-ineligible) → unavailable messaging
 * - state restriction → restricted-state messaging (waitlist CTA ships in
 *   BUT-1114)
 */
const DirectLabsBlockedState = ({ blockedClass }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={styles.container} role="alert">
      {blockedClass === "stateRestricted" ? (
        <Message
          intention="critical"
          title={t(l.labs.CannotOrderInThisState)}
          label={t(l.directLabsCheckout.blocked.stateRestrictedLabel)}
        />
      ) : (
        <Message intention="warning" label={t(l.directLabsCheckout.blocked.unavailableLabel)} />
      )}
    </div>
  );
};

export { DirectLabsBlockedState };
export type { BlockedClass };
